import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "languages-select" }
const _hoisted_2 = ["dir"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Language ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_select = _resolveComponent("ui-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", { dir: _ctx.direction }, [
      _createVNode(_component_ui_select, {
        outlined: "",
        modelValue: _ctx.language,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.language) = $event)),
        options: _ctx.selectData(_ctx.getLanguages),
        dir: _ctx.direction
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["modelValue", "options", "dir"])
    ], 8, _hoisted_2)
  ]))
}